export enum Entity {
  Count = 'count',
  Category = 'category',
  Students = 'students',
  Compensation = 'compensation',
  TotalRow = 'totalRow',
}
